(function () {
  function qs(root, sel) {
    return (root && root.querySelector(sel)) || document.querySelector(sel);
  }

  function textToCents(text) {
    if (!text) return 0;
    var cleaned = ('' + text).replace(/[^\d.,-]/g, '').trim();
    if (!cleaned) return 0;

    // Handle different locales
    if (cleaned.indexOf('.') > -1 && cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(/,/g, ''); // "1,234.56"
    } else if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1) {
      cleaned = cleaned.replace(',', '.'); // "1.234,56" -> "1234.56"
    }

    var num = parseFloat(cleaned);
    if (isNaN(num)) return 0;
    return Math.round(num * 100);
  }

  function getPriceWrap(w) {
    // Only use closest() - no global fallbacks that could grab wrong products
    return w.closest('.price');
  }

  function getQtyInput(w) {
    var form =
      w.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    return (
      form &&
      (form.querySelector('input[name="quantity"]') ||
        form.querySelector('quantity-input input') ||
        form.querySelector('input[type="number"][name="quantity"]'))
    );
  }

  function getPriceCents(w, priceWrap) {
    var dd = priceWrap && priceWrap.querySelector('.price__last[data-last]');
    if (dd && dd.dataset.last) {
      var n = parseInt(dd.dataset.last, 10);
      return isNaN(n) ? 0 : n; // Shopify cents
    }
    var fallback = parseInt(w.dataset.price || '0', 10);
    return isNaN(fallback) ? 0 : fallback;
  }

  // Subtotal helpers
  // UPDATED Feb 4, 2026: Enhanced to find subtotal in Halo theme PDP
  function findSubtotalWrap(w) {
    // First try closest() - best case
    var container = w.closest('.productView-moreItem') || w.closest('.productView');
    if (container) {
      var sub = container.querySelector('.productView-subtotal');
      if (sub) return sub;
    }
    
    // Try finding from the product form context
    var form = w.closest('form[action*="/cart/add"]');
    if (form) {
      // Look for subtotal wrapper within or near the form
      var formParent = form.parentElement;
      while (formParent && formParent !== document.body) {
        var sub = formParent.querySelector('.productView-subtotal');
        if (sub) return sub;
        formParent = formParent.parentElement;
      }
    }
    
    // Fallback: Use product ID to find MATCHING productView only
    // This prevents Recently Viewed products from grabbing main product's subtotal
    var productId = w.dataset.productId;
    if (!productId) {
      // Last resort: find the main product page subtotal (only on product template)
      if (document.body.classList.contains('template-product') || 
          document.querySelector('.productView-subtotal')) {
        var mainSub = document.querySelector('.productView-subtotal');
        if (mainSub) return mainSub;
      }
      return null;
    }
    
    // Find all productViews and check which one belongs to this product
    var allProductViews = document.querySelectorAll('.productView');
    for (var i = 0; i < allProductViews.length; i++) {
      var pv = allProductViews[i];
      
      // Check if this productView has matching product ID
      if (pv.dataset.productId === productId) {
        return pv.querySelector('.productView-subtotal');
      }
      
      // Check if this productView CONTAINS an element with matching product ID
      var matchingElement = pv.querySelector('[data-product-id="' + productId + '"]');
      if (matchingElement) {
        return pv.querySelector('.productView-subtotal');
      }
    }
    
    // Final fallback for product pages: find by product ID in document
    var widgetById = document.querySelector('.product-metafields-entries[data-product-id="' + productId + '"]');
    if (widgetById) {
      var pvSearch = widgetById.closest('.productView') || widgetById.closest('[class*="product"]');
      if (pvSearch) {
        var subSearch = pvSearch.querySelector('.productView-subtotal');
        if (subSearch) return subSearch;
      }
    }
    
    return null;
  }

  function ensureSubtotalLabel(subWrap) {
    // FIX Feb 4, 2026: Check BOTH inside subWrap AND as next sibling to prevent duplication
    var label = subWrap.querySelector('.subtotal-entries');
    if (!label && subWrap.nextElementSibling && subWrap.nextElementSibling.classList && 
        subWrap.nextElementSibling.classList.contains('subtotal-entries')) {
      label = subWrap.nextElementSibling;
    }
    
    if (!label) {
      // Use a div for block-level display (new line below subtotal)
      label = document.createElement('div');
      label.className = 'subtotal-entries';
      label.innerHTML =
        '<span class="product-item-icon">🎟</span> <span class="subtotal-entries-count">0 Entries</span> <span class="subtotal-entries-badge">0X</span>';
      
      // Style the wrapper - block display to go on new line, flex for internal alignment
      label.style.cssText = 'display: flex; align-items: center; gap: 6px; margin-top: 6px; font-size: 16px; font-weight: 900;';
      
      // FIX Feb 4, 2026: Copy badge style from existing .product-entry-badge (dynamic per product)
      var badge = label.querySelector('.subtotal-entries-badge');
      if (badge) {
        // Base styles (padding, radius, font)
        badge.style.cssText = 'padding: 3px 10px; border-radius: 4px; height: fit-content; color: #ffffff; font-size: 14px; font-weight: 900;';
        
        // Find existing badge in same product context and copy its background + text color
        var productContext = subWrap.closest('.productView') || subWrap.closest('.product') || subWrap.closest('section');
        var existingBadge = productContext && productContext.querySelector('.product-entry-badge');
        if (existingBadge) {
          var computed = window.getComputedStyle(existingBadge);
          badge.style.background = computed.background || computed.backgroundColor || 'linear-gradient(180deg, #024285 2%, #0cd4c7 97%)';
          badge.style.color = computed.color || '#ffffff';  // Copy text color (white for 80X, black for 20X)
        } else {
          // Fallback to default gradient if no existing badge found
          badge.style.background = 'linear-gradient(180deg, #024285 2%, #0cd4c7 97%)';
        }
      }

      // Insert AFTER the subtotal wrap (as a sibling, not inside)
      if (subWrap.nextSibling) {
        subWrap.parentNode.insertBefore(label, subWrap.nextSibling);
      } else {
        subWrap.parentNode.appendChild(label);
      }
    }
    return label;
  }

  function updateSubtotal(w) {
    var subWrap = findSubtotalWrap(w);
    if (!subWrap) return;

    var moneyEl = subWrap.querySelector('.money-subtotal');
    if (!moneyEl) return;

    var label = ensureSubtotalLabel(subWrap);
    var mult = parseInt(w.dataset.entriesX || '0', 10);
    if (!mult) {
      label.style.display = 'none';
      return;
    }

    var subtotalCents = textToCents(moneyEl.textContent);
    // Subtotal already includes quantity; so entries = subtotal * multiplier
    var entries = Math.floor((subtotalCents * mult) / 100);
    var count = label.querySelector('.subtotal-entries-count');
    if (count) count.textContent = entries.toLocaleString() + ' Entries';
    
    // Update the multiplier badge
    var badge = label.querySelector('.subtotal-entries-badge');
    if (badge) badge.textContent = mult + 'X';
    
    label.style.display = '';
  }

  function bindSubtotal(w) {
    var subWrap = findSubtotalWrap(w);
    if (!subWrap || subWrap.__entriesSubtotalBound) return;
    subWrap.__entriesSubtotalBound = true;

    var moneyEl = subWrap.querySelector('.money-subtotal');
    if (!moneyEl) return;

    var mo = new MutationObserver(function () {
      updateSubtotal(w);
    });
    mo.observe(moneyEl, { childList: true, characterData: true, subtree: true });

    w.__entriesSubtotalMO = mo;
    updateSubtotal(w);
  }

  function update(w) {
    var mult = parseInt(w.dataset.entriesX || '0', 10);
    if (!mult) return;

    var priceWrap = getPriceWrap(w);
    var cents = getPriceCents(w, priceWrap);
    var ignoreQty = w.hasAttribute('data-ignore-qty');
    var qtyInput = ignoreQty ? null : getQtyInput(w);
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;

    // Price widget (near price)
    var entries = Math.floor((cents * mult * qty) / 100);
    var label = w.querySelector('.entries_meta_cl');
    if (label) label.textContent = entries.toLocaleString() + ' Entries';

    var badge = w.querySelector('.product-entry-badge');
    if (badge) badge.textContent = mult + 'X';

    // Subtotal badge (near .money-subtotal)
    updateSubtotal(w);
  }

  function bind(w) {
    if (w.__entriesBound) return;
    w.__entriesBound = true;

    var priceWrap = getPriceWrap(w);
    var dd = priceWrap && priceWrap.querySelector('.price__last[data-last]');
    if (dd) {
      var mo = new MutationObserver(function () {
        update(w);
      });
      mo.observe(dd, { attributes: true, attributeFilter: ['data-last'] });
      w.__entriesMO = mo;
    }

    var qty = getQtyInput(w);
    if (qty) {
      var h = function () {
        update(w);
      };
      qty.addEventListener('input', h);
      qty.addEventListener('change', h);
      w.__entriesQtyInput = qty;
    }

    // Bind subtotal observer
    bindSubtotal(w);
    update(w);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.product-metafields-entries')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  var globalMO = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes &&
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.product-metafields-entries'))
            bind(node);
          else if (node.querySelectorAll)
            node.querySelectorAll('.product-metafields-entries').forEach(bind);
        });
    });
  });

  globalMO.observe(document.documentElement, { childList: true, subtree: true });

  [
    'variant:changed',
    'theme:variant:change',
    'product:variant-change',
    'product-variant-change',
    'shopify:section:load',
  ].forEach(function (evt) {
    document.addEventListener(evt, function () {
      initAll();
    }, { passive: true });
  });

  // Manual trigger (debug)
  window.EntriesWidgetUpdateAll = function () {
    initAll();
  };
})();


// INPUT FILED DYNAMIC SOURCE

(function(){
  function centsFromMoney(str){
    var s=(''+(str||'')).replace(/[^\d.,-]/g,'').trim();
    if(!s) return 0;
    if(s.indexOf('.')>-1 && s.indexOf(',')>-1){ s = s.replace(/,/g,''); }
    else if(s.indexOf(',')>-1 && s.indexOf('.')===-1){ s = s.replace(',', '.'); }
    var n=parseFloat(s); if(isNaN(n)) return 0;
    return Math.round(n*100);
  }

  function findForm(el){
    return el.closest('form[action*="/cart/add"]') || el.closest('form');
  }
  function findQtyInput(inp){
    var form = findForm(inp);
    if(!form) return null;
    return form.querySelector('input[name="quantity"], quantity-input input.quantity__input, input.quantity__input');
  }
  function findSubtotalEl(inp){
    // ONLY use closest() - NO global fallbacks
    // This prevents grabbing subtotals from other products on the page
    var root = inp.closest('.productView') || inp.closest('.product') || inp.closest('section');
    if (!root) return null;
    return root.querySelector('.productView-subtotal .money-subtotal');
  }
  function findPriceEl(inp){
    // ONLY use closest() - NO global fallbacks
    // This prevents grabbing prices from other products on the page
    var root = inp.closest('.productView') || inp.closest('.product') || inp.closest('section');
    if (!root) return null;
    var dd = root.querySelector('.price .price__last[data-last]');
    if(dd) return dd;
    return root.querySelector('.price .price-item--sale, .price .price-item--regular, .price .price__last');
  }

  function computeEntries(inp){
    var mult = parseInt(inp.getAttribute('data-entries-x') || '0', 10) || 0;
    if(!mult) return 0;

    // Prefer live subtotal if present
    var subtotalEl = findSubtotalEl(inp);
    var cents = subtotalEl ? centsFromMoney(subtotalEl.textContent) : 0;

    // Fallback: price * qty
    if(cents <= 0){
      var priceEl = findPriceEl(inp);
      if(priceEl){
        if(priceEl.getAttribute && priceEl.hasAttribute('data-last')){
          cents = parseInt(priceEl.getAttribute('data-last'), 10) || 0; // cents
        } else {
          cents = centsFromMoney(priceEl.textContent);
        }
      }
      var qtyEl = findQtyInput(inp);
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;
      cents = cents * qty;
    }

    // Entries = subtotal * multiplier / 100
    return Math.floor((cents * mult) / 100);
  }

  function update(inp){
    var mult = parseInt(inp.getAttribute('data-entries-x') || '0', 10) || 0;
    var entries = computeEntries(inp);
    
    // KACHING UPDATE (Jan 19, 2026): Include emoji + multiplier in value
    // This shows "🎟 350 Entries • 20X" in Kaching cart drawer
    inp.value = '🎟 ' + entries.toLocaleString() + ' Entries • ' + mult + 'X';

    // Sync .subtotal-entries-count ONLY within the same product container
    // NO document fallback - prevents polluting other products' subtotals
    var root = inp.closest('.productView') || inp.closest('.product') || inp.closest('section');
    if (root) {
      var pill = root.querySelector('.subtotal-entries-count');
      if(pill) pill.textContent = entries.toLocaleString() + ' Entries';
    }
  }

  function bind(inp){
    if(inp.__entriesBind) return;
    inp.__entriesBind = true;

    // Subtotal text observer (money-subtotal)
    var subEl = findSubtotalEl(inp);
    if(subEl){
      var mo1 = new MutationObserver(function(){ update(inp); });
      mo1.observe(subEl, { childList:true, characterData:true, subtree:true });
      inp.__moSubtotal = mo1;
    }

    // Price attribute observer (data-last)
    var priceEl = findPriceEl(inp);
    if(priceEl && priceEl.hasAttribute && priceEl.hasAttribute('data-last')){
      var mo2 = new MutationObserver(function(){ update(inp); });
      mo2.observe(priceEl, { attributes:true, attributeFilter:['data-last'] });
      inp.__moPrice = mo2;
    }

    // Qty listeners
    var qty = findQtyInput(inp);
    if(qty){
      ['input','change'].forEach(function(evt){
        qty.addEventListener(evt, function(){ update(inp); });
      });
    }

    // Plus/Minus buttons (Ella)
    var root = inp.closest('.productView') || inp.closest('section') || document;
    root.querySelectorAll('.btn-quantity').forEach(function(btn){
      btn.addEventListener('click', function(){
        // Slight delay to let theme update qty/subtotal first
        setTimeout(function(){ update(inp); }, 20);
      });
    });

    // Variant change events
    ['variant:changed','theme:variant:change','product:variant-change','product-variant-change','shopify:section:load']
      .forEach(function(evt){
        document.addEventListener(evt, function(){ update(inp); }, { passive:true });
      });

    // Initial run
    update(inp);
  }

  function init(root){
    (root||document).querySelectorAll('input.entries-input[name="properties[Entries]"]').forEach(bind);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ init(); });
  } else {
    init();
  }

  // Re-bind if theme re-renders fragments
var globalMO = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes &&
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Only bind if it's a NEW widget that hasn't been bound yet
          if (node.matches && node.matches('.product-metafields-entries') && !node.__entriesBound)
            bind(node);
          else if (node.querySelectorAll)
            node.querySelectorAll('.product-metafields-entries').forEach(function(w){
              if (!w.__entriesBound) bind(w);
            });
        });
    });
  });
  globalMO.observe(document.documentElement, { childList:true, subtree:true });

  // Debug helper
  window.EntriesFieldForceUpdate = function(){
    document.querySelectorAll('input.entries-input[name="properties[Entries]"]').forEach(update);
  };
})();


// Cart Page dynaic subtotal code

(function(){
  // === Helpers ===
  function centsFromMoney(str){
    var s=(''+(str||'')).replace(/[^\d.,-]/g,'').trim();
    if(!s) return 0;
    if(s.indexOf('.')>-1 && s.indexOf(',')>-1){ s = s.replace(/,/g,''); }
    else if(s.indexOf(',')>-1 && s.indexOf('.')===-1){ s = s.replace(',', '.'); }
    var n=parseFloat(s); if(isNaN(n)) return 0;
    return Math.round(n*100);
  }
  function intFromEntries(str){
    // "2,250 Entries" -> 2250
    var n=(''+(str||'')).replace(/[^\d]/g,'').trim();
    return n ? parseInt(n,10) : 0;
  }
  function toN(n, d){ n=parseInt(n,10); return isNaN(n)?(d||0):n; }
  function qs(root, sel){ return (root && root.querySelector(sel)) || document.querySelector(sel); }
  function qsa(root, sel){ return (root||document).querySelectorAll(sel); }
  function after(node, newNode){
    if(node && node.parentNode){
      if(node.nextSibling) node.parentNode.insertBefore(newNode, node.nextSibling);
      else node.parentNode.appendChild(newNode);
    }
  }

  // Find all cart item elements
  function getCartItems(root){
    root = root || document;
    // Halo cart page selector
    var list = root.querySelector('.cart-list');
    if(!list) list = root;
    return list.querySelectorAll('.cart-item');
  }

  function findEntriesDD(itemEl){
    // Returns {dt, dd} for the "Entries" property if present
    var opts = itemEl.querySelectorAll('.cart-item-properties .product-option');
    for(var i=0;i<opts.length;i++){
      var dt = opts[i].querySelector('dt');
      var dd = opts[i].querySelector('dd');
      if(!dt || !dd) continue;
      var key = (dt.textContent||'').trim().toLowerCase();
      if(key.indexOf('entries') > -1) return {dt:dt, dd:dd};
    }
    return null;
  }

  function getUnitPriceCents(itemEl){
    // Prefer data-price on total block (per-unit cents)
    var totalBlock = itemEl.querySelector('.cart-item-block.cart-item-total');
    var unit = totalBlock ? toN(totalBlock.getAttribute('data-price'),0) : 0;
    if(unit) return unit;

    // Fallback: derive from visible price (per unit) or from line total / qty
    var unitTxt = itemEl.querySelector('.cart-item-block.cart-item-price [data-item-final-price-display], .cart-item-block.cart-item-price .price--end, .cart-item__price-wrapper [data-item-final-price-display]');
    if(unitTxt){
      var c = centsFromMoney(unitTxt.textContent);
      if(c) return c;
    }

    // Derive from line total / qty
    var lineTxt = itemEl.querySelector('.cart-item-block.cart-item-total [data-item-price-with-quantity-display], .cart-item-block.cart-item-total .cart-item-value');
    var qty = getQty(itemEl);
    if(lineTxt && qty){
      var lineCents = centsFromMoney(lineTxt.textContent);
      if(lineCents) return Math.round(lineCents / Math.max(1, qty));
    }
    return 0;
  }

  function getQty(itemEl){
    var inp = itemEl.querySelector('input.cart-item-qty-input, input[name="quantity"]');
    var v = inp ? parseInt(inp.value||'1',10) : 1;
    return isNaN(v) ? 1 : Math.max(1, v);
  }

  function getLineKey(itemEl){
    // Use data-line if available, else unique per element
    var k = itemEl.getAttribute('data-line') || '';
    if(!k){
      if(!itemEl.__entriesLineKey) itemEl.__entriesLineKey = 'line-'+Math.random().toString(36).slice(2);
      k = itemEl.__entriesLineKey;
    }
    return k;
  }

  // Cache multipliers per line so we can keep Entries accurate on qty change
  var lineMultipliers = {}; // key -> mult int

  function computeOrDeriveMultiplier(itemEl, entriesFromDD){
    var key = getLineKey(itemEl);
    var cached = toN(lineMultipliers[key],0);
    if(cached) return cached;

    var unitCents = getUnitPriceCents(itemEl);
    var qty = getQty(itemEl);
    if(entriesFromDD && unitCents && qty){
      // mult = entries * 100 / (unitCents * qty)
      var mult = Math.round((entriesFromDD * 100) / (unitCents * qty));
      if(mult > 0){
        lineMultipliers[key] = mult;
        return mult;
      }
    }

    // As a last resort, try data-attributes
    var guess = toN(itemEl.getAttribute('data-entries-x'),0);
    if(guess){
      lineMultipliers[key] = guess;
      return guess;
    }

    return 0;
  }

  function computeLineEntries(itemEl){
    var pair = findEntriesDD(itemEl);
    
    // FIX (Jan 19, 2026): Only calculate entries if there's an actual "Entries" line item property
    // This prevents showing entries from data-entries-x attribute when giveaway is inactive
    if (!pair) {
      return { entries: 0, ddNode: null };
    }
    
    var ddEntries = intFromEntries(pair.dd.textContent);
    var mult = computeOrDeriveMultiplier(itemEl, ddEntries);
    var unitCents = getUnitPriceCents(itemEl);
    var qty = getQty(itemEl);

    var entriesCurrent = 0;
    if(mult && unitCents){
      entriesCurrent = Math.floor((unitCents * qty * mult) / 100);
    } else if(ddEntries){
      // fallback to static property value
      entriesCurrent = ddEntries;
    }

    return {
      entries: entriesCurrent,
      ddNode: pair.dd
    };
  }

  function sumAllEntries(root){
    var items = getCartItems(root);
    var total = 0;
    items.forEach ? items.forEach(function(it){ total += computeLineEntries(it).entries; }) :
      Array.prototype.forEach.call(items, function(it){ total += computeLineEntries(it).entries; });
    return total;
  }

  function ensureEntriesRow(ul){
    var row = ul.querySelector('li.cart-total-entries[data-entries-subtotal]');
    if(row) return row;

    row = document.createElement('li');
    row.className = 'cart-total cart-total-entries';
    row.setAttribute('data-entries-subtotal','');
    row.innerHTML =
      '<div class="cart-total-label"><span class="text">Entries</span></div>' +
      '<div class="cart-total-value">' +
        '<span class="text"><span class="product-item-icon">🎟</span> ' +
        '<span class="entries-subtotal-count">0 Entries</span></span>' +
      '</div>';

    var sub = ul.querySelector('.cart-total-subtotal');
    if(sub) after(sub, row); else ul.appendChild(row);
    return row;
  }

  function updateEntriesRow(ul, totalEntries){
    var row = ensureEntriesRow(ul);
    var count = row.querySelector('.entries-subtotal-count');
    if(count) count.textContent = totalEntries.toLocaleString() + ' Entries';
    row.style.display = totalEntries > 0 ? '' : 'none';
  }

  function updateCartEntriesUI(root){
    // 1) Sum over all lines
    var total = sumAllEntries(root || document);

    // 2) Update every cart totals block
    var totalsLists = qsa(document, 'ul.cart-totals');
    totalsLists.forEach(function(ul){ updateEntriesRow(ul, total); });

    // 3) Optional: sync each line's DD to current entries (UI only)
    getCartItems(root || document).forEach(function(itemEl){
      var line = computeLineEntries(itemEl);
      if(line.ddNode){
        var want = line.entries.toLocaleString() + ' Entries';
        if(line.ddNode.textContent !== want) line.ddNode.textContent = want;
      }
    });
  }

  // === Binding & Reactivity ===
  function bindQtyListeners(root){
    (root||document).querySelectorAll('input.cart-item-qty-input, input[name="quantity"]').forEach(function(inp){
      if(inp.__entriesQtyBound) return;
      inp.__entriesQtyBound = true;
      ['input','change'].forEach(function(evt){
        inp.addEventListener(evt, function(){ setTimeout(updateCartEntriesUI, 30); });
      });
    });

    // Plus/Minus buttons
    (root||document).querySelectorAll('.btn-quantity').forEach(function(btn){
      if(btn.__entriesBtnBound) return;
      btn.__entriesBtnBound = true;
      btn.addEventListener('click', function(){ setTimeout(updateCartEntriesUI, 30); });
    });
  }

  function observeRoot(root){
    if(!root || root.__entriesCartMO) return;
    var mo = new MutationObserver(function(){
      // Re-calc and re-bind when cart DOM updates
      bindQtyListeners(root);
      updateCartEntriesUI(root);
    });
    mo.observe(root, { childList:true, subtree:true, characterData:true });
    root.__entriesCartMO = mo;
  }

  function init(){
    // Cart page main container
    var cartMain = document.getElementById('main-cart-items') || document.querySelector('.halo-cart-content') || document;

    bindQtyListeners(document);
    updateCartEntriesUI(document);

    observeRoot(cartMain);

    // Try to observe common drawer containers too (if present)
    ['#CartDrawer','.halo-sidebar','.halo-cart-sidebar','.mini-cart','cart-drawer','cart-drawer-items'].forEach(function(sel){
      var el = document.querySelector(sel);
      if(el) observeRoot(el);
    });

    // Hook into common theme events
    ['shopify:section:load','cart:updated','ajaxCart:updated','cart:change','cart:refresh'].forEach(function(evt){
      document.addEventListener(evt, function(){ setTimeout(function(){
        bindQtyListeners(document);
        updateCartEntriesUI(document);
      }, 20); }, { passive:true });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Debug helper
  window.CartEntriesForceUpdate = function(){ updateCartEntriesUI(document); };
})();

// Qty input, plus/minus, remove, aur AJAX re-render per auto update

(function () {
  if (window.__EntriesCartUnifiedV2) return;
  window.__EntriesCartUnifiedV2 = true;

  var rAF = window.requestAnimationFrame || function (cb) {
    return setTimeout(cb, 16);
  };

  function throttleFrame(fn) {
    var pending = false;
    return function () {
      if (pending) return;
      pending = true;
      rAF(function () {
        pending = false;
        try {
          fn();
        } catch (e) {
          console.error('[Entries Subtotal]', e);
        }
      });
    };
  }

  // ===== Helpers =====
  function centsFromMoney(str) {
    var s = ('' + (str || '')).replace(/[^\d.,-]/g, '').trim();
    if (!s) return 0;
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      s = s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1 && s.indexOf('.') === -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function intFromEntries(str) {
    var n = ('' + (str || '')).replace(/[^\d]/g, '').trim();
    return n ? parseInt(n, 10) : 0;
  }

  function toInt(v, d) {
    v = parseInt(v, 10);
    return isNaN(v) ? (d || 0) : v;
  }

  function after(node, newNode) {
    if (!node || !node.parentNode) return;
    if (node.nextSibling) node.parentNode.insertBefore(newNode, node.nextSibling);
    else node.parentNode.appendChild(newNode);
  }

  function setTextIfDiff(el, txt) {
    if (!el) return;
    if (el.textContent !== txt) el.textContent = txt;
  }

  // Multiplier cache shared across cart + sidebar
  var lineMultipliers = Object.create(null);

  // ===== CART PAGE =====
  function getCartRoot() {
    return document.getElementById('main-cart-items') || document.querySelector('.halo-cart-content');
  }

  function getCartItems(root) {
    var list = root && (root.querySelector('.cart-list') || root);
    return list ? list.querySelectorAll('.cart-item') : [];
  }

  function getCartQty(itemEl) {
    var inp = itemEl.querySelector('input.cart-item-qty-input, input[name="quantity"]');
    var v = inp ? parseInt(inp.value || '1', 10) : 1;
    return isNaN(v) ? 1 : Math.max(1, v);
  }

  function getCartLineKey(itemEl) {
    var k = itemEl.getAttribute('data-line') ||
      (itemEl.querySelector('[data-line]') && itemEl.querySelector('[data-line]').getAttribute('data-line')) || '';
    if (!k) {
      if (!itemEl.__entriesLineKey) itemEl.__entriesLineKey = 'line-' + Math.random().toString(36).slice(2);
      k = itemEl.__entriesLineKey;
    }
    return k;
  }

  function findCartEntriesDD(itemEl) {
    var opts = itemEl.querySelectorAll('.cart-item-properties .product-option');
    for (var i = 0; i < opts.length; i++) {
      var dt = opts[i].querySelector('dt');
      var dd = opts[i].querySelector('dd');
      if (!dt || !dd) continue;
      var key = (dt.textContent || '').trim().toLowerCase();
      if (key.indexOf('entries') > -1) return { dt: dt, dd: dd };
    }
    return null;
  }

  function getCartUnitPriceCents(itemEl) {
    var totalBlock = itemEl.querySelector('.cart-item-block.cart-item-total');
    var unit = totalBlock ? toInt(totalBlock.getAttribute('data-price'), 0) : 0;
    if (unit) return unit;
    var unitTxt = itemEl.querySelector(
      '.cart-item-block.cart-item-price [data-item-final-price-display], .cart-item-block.cart-item-price .price--end, .cart-item__price-wrapper [data-item-final-price-display]'
    );
    if (unitTxt) {
      var c = centsFromMoney(unitTxt.textContent);
      if (c) return c;
    }
    var lineTxt = itemEl.querySelector(
      '.cart-item-block.cart-item-total [data-item-price-with-quantity-display], .cart-item-block.cart-item-total .cart-item-value'
    );
    var qty = getCartQty(itemEl);
    if (lineTxt && qty) {
      var lineCents = centsFromMoney(lineTxt.textContent);
      if (lineCents) return Math.round(lineCents / Math.max(1, qty));
    }
    return 0;
  }

  function computeOrDeriveCartMult(itemEl, ddEntries) {
    var key = getCartLineKey(itemEl);
    var cached = toInt(lineMultipliers[key], 0);
    if (cached) return cached;
    var attrX = toInt(itemEl.getAttribute('data-entries-x'), 0);
    if (attrX) {
      lineMultipliers[key] = attrX;
      return attrX;
    }
    var unitCents = getCartUnitPriceCents(itemEl);
    var qty = getCartQty(itemEl);
    if (ddEntries && unitCents && qty) {
      var mult = Math.round((ddEntries * 100) / (unitCents * qty));
      if (mult > 0) {
        lineMultipliers[key] = mult;
        return mult;
      }
    }
    return 0;
  }

  function computeCartLine(itemEl) {
    var pair = findCartEntriesDD(itemEl);
    
    // FIX (Jan 19, 2026): Only calculate entries if there's an actual "Entries" line item property
    // This prevents showing entries from data-entries-x attribute when giveaway is inactive
    if (!pair) {
      return { entries: 0, ddNode: null };
    }
    
    var ddEntries = intFromEntries(pair.dd.textContent);
    var mult = computeOrDeriveCartMult(itemEl, ddEntries);
    var unitCents = getCartUnitPriceCents(itemEl);
    var qty = getCartQty(itemEl);
    var entries = 0;
    if (mult && unitCents) {
      entries = Math.floor((unitCents * qty * mult) / 100);
    } else if (ddEntries) {
      entries = ddEntries;
    }
    return { entries: entries, ddNode: pair.dd };
  }

  function sumCartEntries(root) {
    var items = getCartItems(root);
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      total += computeCartLine(items[i]).entries;
    }
    return total;
  }

  function ensureCartEntriesRow(ul) {
    var row = ul.querySelector('li.cart-total-entries[data-entries-subtotal]');
    if (row) return row;
    row = document.createElement('li');
    row.className = 'cart-total cart-total-entries';
    row.setAttribute('data-entries-subtotal', '');
    row.innerHTML =
      '<div class="cart-total-label"><span class="text">Entries</span></div>' +
      '<div class="cart-total-value"><span class="text"><span class="product-item-icon">🎟</span> ' +
      '<span class="entries-subtotal-count">0 Entries</span></span></div>';
    var sub = ul.querySelector('.cart-total-subtotal');
    if (sub) after(sub, row);
    else ul.appendChild(row);
    return row;
  }

  function updateCartTotalsUI(root) {
    var total = sumCartEntries(root);
    var lists = document.querySelectorAll('ul.cart-totals');
    for (var i = 0; i < lists.length; i++) {
      var row = ensureCartEntriesRow(lists[i]);
      var count = row.querySelector('.entries-subtotal-count');
      setTextIfDiff(count, total.toLocaleString() + ' Entries');
      row.style.display = total > 0 ? '' : 'none';
    }
    var items = getCartItems(root);
    for (var j = 0; j < items.length; j++) {
      var l = computeCartLine(items[j]);
      if (l.ddNode) {
        var want = l.entries.toLocaleString() + ' Entries';
        setTextIfDiff(l.ddNode, want);
      }
    }
  }

  function bindCartListeners(root, scheduleUpdate) {
    var qts = root.querySelectorAll('input.cart-item-qty-input, input[name="quantity"]');
    for (var i = 0; i < qts.length; i++) {
      var inp = qts[i];
      if (inp.__entriesBound) continue;
      inp.__entriesBound = true;
      ['input', 'change'].forEach(function (evt) {
        inp.addEventListener(evt, function () {
          scheduleUpdate();
        });
      });
    }

    var btns = root.querySelectorAll('.btn-quantity');
    for (var j = 0; j < btns.length; j++) {
      var b = btns[j];
      if (b.__entriesBound) continue;
      b.__entriesBound = true;
      b.addEventListener('click', function () {
        setTimeout(scheduleUpdate, 30);
      });
    }

    var rms = root.querySelectorAll('[data-cart-remove]');
    for (var k = 0; k < rms.length; k++) {
      var r = rms[k];
      if (r.__entriesBound) continue;
      r.__entriesBound = true;
      r.addEventListener('click', function () {
        setTimeout(scheduleUpdate, 80);
      });
    }
  }

  function initCart() {
    var root = getCartRoot();
    if (!root) return;
    var scheduleUpdate = throttleFrame(function () {
      bindCartListeners(root, scheduleUpdate);
      updateCartTotalsUI(root);
    });
    scheduleUpdate();

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'childList') {
          scheduleUpdate();
          break;
        }
      }
    });
    mo.observe(root, { childList: true, subtree: true });
    root.__entriesCartMO = mo;

    ['shopify:section:load', 'cart:updated', 'ajaxCart:updated', 'cart:change', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(scheduleUpdate, 30);
      }, { passive: true });
    });

    window.CartEntriesForceUpdate = scheduleUpdate;
  }

  // ===== SIDEBAR / DRAWER =====
  function getSidebarRoot() {
    return document.getElementById('halo-cart-sidebar');
  }

  function getSidebarItems(root) {
    return root ? root.querySelectorAll('.previewCartItem') : [];
  }

  function findSidebarEntriesDD(itemEl) {
    var opts = itemEl.querySelectorAll('dl.definitionList .product-option');
    for (var i = 0; i < opts.length; i++) {
      var dt = opts[i].querySelector('dt');
      var dd = opts[i].querySelector('dd');
      if (!dt || !dd) continue;
      var key = (dt.textContent || '').trim().toLowerCase();
      if (key.indexOf('entries') > -1) return { dt: dt, dd: dd };
    }
    return null;
  }

  function getSidebarQty(itemEl) {
    var inp = itemEl.querySelector('input[name="quantity"]');
    var v = inp ? parseInt(inp.value || '1', 10) : 1;
    return isNaN(v) ? 1 : Math.max(1, v);
  }

  function getSidebarLineKey(itemEl) {
    var k = itemEl.getAttribute('data-line') ||
      (itemEl.querySelector('[data-line]') && itemEl.querySelector('[data-line]').getAttribute('data-line')) ||
      itemEl.getAttribute('data-variant-id') || '';
    if (!k) {
      if (!itemEl.__entriesLineKey) itemEl.__entriesLineKey = 'sline-' + Math.random().toString(36).slice(2);
      k = itemEl.__entriesLineKey;
    }
    return k;
  }

  function getSidebarUnitPriceCents(itemEl) {
    var priceWrap = itemEl.querySelector('.previewCartItem-price');
    var unit = priceWrap ? toInt(priceWrap.getAttribute('data-price'), 0) : 0;
    if (unit) return unit;
    var unitTxt = itemEl.querySelector('.previewCartItem-price [data-item-final-price-display], .previewCartItem-price .price');
    if (unitTxt) {
      var c = centsFromMoney(unitTxt.textContent);
      if (c) return c;
    }
    return 0;
  }

  function computeOrDeriveSidebarMult(itemEl, ddEntries) {
    var key = getSidebarLineKey(itemEl);
    var cached = toInt(lineMultipliers[key], 0);
    if (cached) return cached;
    var attrX = toInt(itemEl.getAttribute('data-entries-x'), 0);
    if (attrX) {
      lineMultipliers[key] = attrX;
      return attrX;
    }
    var unitCents = getSidebarUnitPriceCents(itemEl);
    var qty = getSidebarQty(itemEl);
    if (ddEntries && unitCents && qty) {
      var mult = Math.round((ddEntries * 100) / (unitCents * qty));
      if (mult > 0) {
        lineMultipliers[key] = mult;
        return mult;
      }
    }
    return 0;
  }

  function computeSidebarLine(itemEl) {
    var pair = findSidebarEntriesDD(itemEl);
    
    // FIX (Jan 19, 2026): Only calculate entries if there's an actual "Entries" line item property
    // This prevents showing entries from data-entries-x attribute when giveaway is inactive
    if (!pair) {
      return { entries: 0, ddNode: null };
    }
    
    var ddEntries = intFromEntries(pair.dd.textContent);
    var mult = computeOrDeriveSidebarMult(itemEl, ddEntries);
    var unitCents = getSidebarUnitPriceCents(itemEl);
    var qty = getSidebarQty(itemEl);
    var entries = 0;
    if (mult && unitCents) {
      entries = Math.floor((unitCents * qty * mult) / 100);
    } else if (ddEntries) {
      entries = ddEntries;
    }
    return { entries: entries, ddNode: pair.dd };
  }

  function sumSidebarEntries(root) {
    var items = getSidebarItems(root);
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      total += computeSidebarLine(items[i]).entries;
    }
    return total;
  }

  function ensureSidebarEntriesRow(ul) {
    var row = ul.querySelector('li.previewCartTotals.entries[data-entries-subtotal]');
    if (row) return row;
    row = document.createElement('li');
    row.className = 'previewCartTotals entries clearfix';
    row.setAttribute('data-entries-subtotal', '');
    row.innerHTML =
      '<div class="previewCartTotals-label">Entries:</div>' +
      '<div class="previewCartTotals-value"><span class="product-item-icon">🎟</span> ' +
      '<span class="entries-subtotal-count">0 Entries</span></div>';
    var sub = ul.querySelector('.previewCartTotals.subTotal');
    if (sub) after(sub, row);
    else ul.appendChild(row);
    return row;
  }

  function updateSidebarUI(root) {
    var total = sumSidebarEntries(root);
    var lists = root.querySelectorAll('ul.previewCartTotalsPrice');
    for (var i = 0; i < lists.length; i++) {
      var row = ensureSidebarEntriesRow(lists[i]);
      var count = row.querySelector('.entries-subtotal-count');
      setTextIfDiff(count, total.toLocaleString() + ' Entries');
      row.style.display = total > 0 ? '' : 'none';
    }
    var items = getSidebarItems(root);
    for (var j = 0; j < items.length; j++) {
      var l = computeSidebarLine(items[j]);
      if (l.ddNode) {
        var want = l.entries.toLocaleString() + ' Entries';
        setTextIfDiff(l.ddNode, want);
      }
    }
  }

  function bindSidebarListeners(root, scheduleUpdate) {
    var qts = root.querySelectorAll('.previewCartItem input[name="quantity"]');
    for (var i = 0; i < qts.length; i++) {
      var inp = qts[i];
      if (inp.__entriesBound) continue;
      inp.__entriesBound = true;
      ['input', 'change'].forEach(function (evt) {
        inp.addEventListener(evt, function () {
          scheduleUpdate();
        });
      });
    }

    var btns = root.querySelectorAll('.previewCartItem .btn-quantity');
    for (var j = 0; j < btns.length; j++) {
      var b = btns[j];
      if (b.__entriesBound) continue;
      b.__entriesBound = true;
      b.addEventListener('click', function () {
        setTimeout(scheduleUpdate, 30);
      });
    }

    var rms = root.querySelectorAll('[data-cart-remove]');
    for (var k = 0; k < rms.length; k++) {
      var r = rms[k];
      if (r.__entriesBound) continue;
      r.__entriesBound = true;
      r.addEventListener('click', function () {
        setTimeout(scheduleUpdate, 80);
      });
    }
  }

  function initSidebar() {
    var root = getSidebarRoot();
    if (!root) return;
    var scheduleUpdate = throttleFrame(function () {
      bindSidebarListeners(root, scheduleUpdate);
      updateSidebarUI(root);
    });
    scheduleUpdate();

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'childList') {
          scheduleUpdate();
          break;
        }
      }
    });
    mo.observe(root, { childList: true, subtree: true });
    root.__entriesSidebarMO = mo;

    ['shopify:section:load', 'cart:updated', 'ajaxCart:updated', 'cart:change', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(scheduleUpdate, 30);
      }, { passive: true });
    });

    window.SidebarEntriesForceUpdate = scheduleUpdate;
  }

  // ===== Init both =====
  function initAll() {
    initCart();
    initSidebar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Diagnostics (optional)
  window.EntriesDiag = function () {
    var cartRoot = getCartRoot();
    var sidebarRoot = getSidebarRoot();
    return {
      cartItems: cartRoot ? getCartItems(cartRoot).length : 0,
      cartEntriesTotal: cartRoot ? sumCartEntries(cartRoot) : 0,
      sidebarItems: sidebarRoot ? getSidebarItems(sidebarRoot).length : 0,
      sidebarEntriesTotal: sidebarRoot ? sumSidebarEntries(sidebarRoot) : 0
    };
  };
})();
